import { memo, useState } from 'react';
import { LeaveRequestFormValues } from '@Features/EmployeeSelfService/requests/LeaveRequest/form/type';
import { Col, Form, Row } from 'antd';
import { FormikProps } from 'formik';
import { SelectEmployeeCard } from '@Components/Base';
import { UserReplacement } from '@Types/index';

interface ReplacementDetailsSectionProps {
  label?: string;
  formik: FormikProps<LeaveRequestFormValues>;
  listOfUsers: UserReplacement[];
  isReplacementRequired: boolean;
  onSearch: (searchValue: string) => void;
  onLoadMore: () => void;
}

const ReplacementDetailsSection: React.FC<ReplacementDetailsSectionProps> = ({
  formik,
  listOfUsers,
  isReplacementRequired,
  onLoadMore,
  onSearch,
}) => {
  const [empPhoto, setEmpPhoto] = useState<string | null>(null);

  if (!isReplacementRequired) {
    return null;
  }

  const setValueToFormik = (
    userName: string,
    userNumber: string,
    occupation: string,
    empImageName: string | null
  ): void => {
    formik.setFieldValue('replacementEmpNo', userNumber).then(() => {
      formik.setFieldTouched('replacementEmpNo', true);
    });

    formik.setFieldValue('replacementEmpName', userName);
    formik.setFieldValue('replacementEmpDesignation', occupation);

    setEmpPhoto(empImageName);
  };

  const user =
    formik.values.replacementEmpName && formik.values.replacementEmpDesignation
      ? {
          name: formik.values.replacementEmpName,
          occupation: formik.values.replacementEmpDesignation,
          empImageName: empPhoto,
        }
      : undefined;

  return (
    <Row>
      <Col span={24}>
        <Form.Item label="Choose Your Replacement By Entering Their Employee ID or Employee Name">
          <SelectEmployeeCard
            user={user}
            listOfUsers={listOfUsers}
            setValueToFormik={setValueToFormik}
            onSearch={onSearch}
            onLoadMore={onLoadMore}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default memo(ReplacementDetailsSection);
